import "./HotelRevenueAuditFreePaid.module.css";
import Header from "@/reusable_sections/Header";
import Audithero from "./sections/Audithero";
import RevenueAudit from "./sections/RevenueAudit";
import RevenueAuditChecklist from "./sections/RevenueAuditChecklist";
import Auditcomparisonfaq from "./sections/Auditcomparisonfaq";
import Audit from "./sections/Audit";
import Footer from "@/reusable_sections/Footer";
export default function HotelRevenueAuditFreePaidPage() {
  return <div>
      <Header />
      <Audithero />
      <RevenueAudit />
      <RevenueAuditChecklist />
      <Auditcomparisonfaq />
      <Audit />
      <Footer />
    </div>;
}